/**
 * 7 готовых ИИ-ролей (ru + en). Единый источник для блока ролей на главной
 * и перелинковки на /digital/<slug>. Тексты title/body — как были в секции
 * DigitalRoster, не править без синхронной правки обеих локалей.
 *
 * fullAi — роли, где операционную рутину функция отдаёт ИИ полностью.
 */
export type RoleCopy = { title: string; body: string }
export type Role = { slug: string; fullAi?: boolean; ru: RoleCopy; en: RoleCopy }

export const ROLES: Role[] = [
  {
    slug: 'analitik',
    fullAi: true,
    ru: {
      title: 'AI аналитик',
      body: 'Отвечает на бизнес-вопросы по данным. Сводит отчёты, ловит аномалии. Покрытие решений цифрами — до 90%.',
    },
    en: {
      title: 'AI Analyst',
      body: 'Answers business questions from your data. Builds reports, catches anomalies. Up to 90% of decisions backed by numbers.',
    },
  },
  {
    slug: 'yurist',
    fullAi: true,
    ru: {
      title: 'AI юрист',
      body: 'Проверяет договоры за 5 минут вместо 2 часов. Готовит претензии, типовые ответы 24/7. Рутина живого юриста −60%.',
    },
    en: {
      title: 'AI Lawyer',
      body: 'Reviews contracts in 5 minutes instead of 2 hours. Drafts claims and standard replies 24/7. Human lawyer routine −60%.',
    },
  },
  {
    slug: 'marketolog',
    ru: {
      title: 'AI маркетолог',
      body: 'Контент бренд-голосом, кампании в Я.Директ / VK / TG, A/B-тесты. Запуск кампаний в 3–5 раз быстрее.',
    },
    en: {
      title: 'AI Marketer',
      body: 'Brand-voice content, ad campaigns across your channels, A/B tests. Campaign launches 3–5× faster.',
    },
  },
  {
    slug: 'prodavec',
    fullAi: true,
    ru: {
      title: 'AI продавец',
      body: 'Квалифицирует лидов 24/7, ведёт по воронке, готовит карточки звонков. Конверсия в встречу +30–50%.',
    },
    en: {
      title: 'AI Sales Rep',
      body: 'Qualifies leads 24/7, moves them down the funnel, prepares call briefs. Meeting conversion +30–50%.',
    },
  },
  {
    slug: 'findir',
    ru: {
      title: 'AI финдир',
      body: 'Финмодель в реальном времени, P&L и cash-flow, сценарный анализ. Отчёт за час вместо 2–3 дней.',
    },
    en: {
      title: 'AI CFO',
      body: 'Real-time financial model, P&L and cash flow, scenario analysis. Reports in an hour instead of 2–3 days.',
    },
  },
  {
    slug: 'buhgalter',
    fullAi: true,
    ru: {
      title: 'AI бухгалтер',
      body: 'Первичка в 1С за 30 секунд / документ. Сверки, черновики УСН/НДС/6-НДФЛ. Рутина бухгалтерии −50%.',
    },
    en: {
      title: 'AI Accountant',
      body: 'Source documents into your accounting system in 30 seconds each. Reconciliations, tax filing drafts. Accounting routine −50%.',
    },
  },
  {
    slug: 'assistent',
    ru: {
      title: 'AI ассистент собственника',
      body: 'Календарь, брифы, протоколы, исследования, контроль команды. Возвращает 15–25 часов в неделю.',
    },
    en: {
      title: 'AI Executive Assistant',
      body: 'Calendar, briefs, meeting notes, research, team follow-ups. Gives the owner back 15–25 hours a week.',
    },
  },
]
